import { Flex, Message, TextContent } from 'components';

function StageFirst() {
  return (
    <Flex
      direction='column'
      gap={10}
    >
      <Message
        type='info'
        title='Короткая справка'
      >
        <TextContent element='p'>
          Выше представлены настройки поиска рейсов, укажите необходимые город отправления, город назначения, желаемую
          дату отправления и вам будут представлены все существующие в сервисе рейсы!
        </TextContent>

        <TextContent element='p'>
          У нас можно купить билеты у проверенных перевозчиков — от крупных автобусных компаний до региональных
          перевозчиков.
        </TextContent>

        <TextContent element='p'>
          ✔ По России — билеты на автобусы между городами (Чита, Борзя и др.);
          <br />✔ За пределы страны — Китай.
        </TextContent>

        <TextContent element='p'>Билеты — онлайн и без очередей. 🚌✨</TextContent>
      </Message>

      <Message
        type='warning'
        title='Внимание!'
      >
        <TextContent element='p'>
          На некоторые рейсы перевозчик может попросить указать внутренний паспорт Российской Федерации, заграничный
          паспорт или иностранную визу, пожалуйста, заполняйте все поля внимательно.
        </TextContent>
        <TextContent element='p'>
          Если перевозчику покажется, что во введёных вами данных есть ошибка, он может направить вам письмо на
          электронную почту или позвонить на указанный при регистрации номер телефона, будьте к этому готовы!
        </TextContent>
      </Message>
    </Flex>
  );
}

export default StageFirst;
